import { activeFilterParts, type FilterableColumn } from "./columnFilters";

export const columnsWithActiveFilter = (columns: (FilterableColumn & { key: string })[]): string[] =>
  columns
    .filter((column) => {
      const parts = activeFilterParts(column);
      return parts.includes("search") || (column.isFilterActive ?? parts.length > 0);
    })
    .map((column) => column.key);

export const filteredColumnKeys = (
  columns: (FilterableColumn & { key: string })[],
  defaultFilterColumnKeys: string[] = [],
): Set<string> => new Set(columnsWithActiveFilter(columns).filter((key) => !defaultFilterColumnKeys.includes(key)));

export const withLockedColumnsShown = <C extends FilterableColumn & { key: string }>(
  columns: C[],
  defaultFilterColumnKeys: string[] = [],
): C[] => {
  const filtered = filteredColumnKeys(columns, defaultFilterColumnKeys);
  return columns.map((column) =>
    column.hidden && (column.alwaysShown || filtered.has(column.key)) ? { ...column, hidden: false } : column,
  );
};
